import React, { useContext, useEffect, useRef, useState } from 'react';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonButtons, IonMenuButton, IonGrid, IonRow, IonCol, IonBackButton, IonButton, IonIcon, IonList, IonItem, IonLabel, IonInput, IonTextarea, IonToggle, IonCheckbox, IonLoading, IonRefresher, IonRefresherContent, IonToast, IonRouterContext, IonCard, IonDatetime, IonCardHeader, IonCardContent, IonModal, IonSelect, IonSelectOption, IonAlert, IonItemDivider, useIonViewWillEnter, useIonViewDidEnter, useIonViewWillLeave, useIonViewDidLeave } from '@ionic/react';

import { connect } from '../../data/connect';
import './StockReport.scss';
import API from '../../services';
import { RouteComponentProps, RouteProps, withRouter } from 'react-router';
import { add, arrowRedo, cartOutline, cash, closeCircle, eyeOutline, grid, informationCircleOutline, list, newspaperOutline, pencil, printOutline, remove, save as saveicon, saveOutline, search, send, trashBin } from 'ionicons/icons';
import Form from '../../components/ActiveForm/Form';
import { getOptionsdata, getTemplate } from '../../data/form/template';
import Selectfield from '../../components/ActiveForm/Selectfield';
import SearchItemForm from '../Stockopname/SearchItemForm';
import NumberFormat from 'react-number-format';
import SearchPartnerForm from '../Partner/SearchPartnerForm';
import ViewPartnerForm from '../Partner/ViewPartnerForm';
import AddPartnerForm from '../Partner/AddPartnerForm';
import EditPartnerForm from '../Partner/EditPartnerForm';
import NumericField from '../../components/ActiveForm/NumericField';
import ReactHTMLTableToExcel from '../../components/react-html-table-to-excel/src/ReactHTMLTableToExcel';
import ReactExport from "../../components/react-export-excel/dist";
// import ReactExport from "../../components/react-data-export/dist"
// import ExcelFile from '../../components/react-export-excel/src/ExcelPlugin/components/ExcelFile';
// import ExcelSheet from '../../components/react-export-excel/src/ExcelPlugin/elements/ExcelSheet';
import DateInput from '../../components/ActiveForm/DateInput';

interface OwnProps extends RouteProps {}

interface StateProps {
 
};

interface DispatchProps {

}

type StockReportProps = OwnProps & StateProps & DispatchProps;

const StockReport: React.FC<StockReportProps> = ({location}) => {
  const ionRouterContext = useContext(IonRouterContext);
  var today = new Date();

  const initdate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

  const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const apipath = 'sale';
    const [params,setParams] = useState({
        DateFrom:initdate
        ,DateTo:initdate
        ,InventoryID:0
        ,ItemID:0
        ,ItemGroupID:0
    })
    const [errors,setErrors] = useState(
        []
    );

    const [errordetails,setErrordetails] = useState<any>(
        []
    );
    const [ischanged,setIschanged]=useState(false);
    const [data,setData] = useState<any>();
    const [salesummary,setSalesummary] = useState<any>([]);
    const [saleitemsummary,setSaleitemsummary] = useState<any>([]);

    const [details,setDetails] = useState<any>([]);
    const [currencylist,setCurrencylist] = useState<any>([]);
    const [currency,setCurrency] = useState<any>([]);
    const [isReadonly, setIsReadOnly] = useState(false);

    const [showCompleteToast, setShowCompleteToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [showLoading, setShowLoading] = useState(false);
    const [showSearchItemModal, setShowSearchItemModal] = useState(false);
    const [showSearchParnerModal, setShowSearchPartnerModal] = useState(false);
    const [showViewParnerModal, setShowViewPartnerModal] = useState(false);
    const [showAddParnerModal, setShowAddPartnerModal] = useState(false);
    const [showEditParnerModal, setShowEditPartnerModal] = useState(false);

    const [myInventory, setMyInventory] = useState<any>([]);
    const [currentInventory,setCurrentInventory] = useState<any>();
    const [itemgrouplist, setItemgrouplist] = useState<any>([]);
    const [itemlist, setItemlist] = useState<any>([]);
    const [selecteditem,setSelecteditem] = useState<any>();
    const [selecteditemgroup,setSelecteditemgroup] = useState<any>();
    const [showAlert1, setShowAlert1] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertHeader, setAlertHeader] = useState("Warning");
    const [alertMessage, setAlertMessage] = useState("Warning");
    const [alertButtons, setAlertButtons] = useState<any>(['Ok']);
    const [selectdate,setSelectdate]= useState('today');
    const [iscustomdate,setIscustomdate]=useState(false);
    const pageRef = useRef<HTMLElement>(null);
    const [filename,setFilename] = useState("");
    const ionRefresherRef = useRef<HTMLIonRefresherElement>(null);

    const handleChange = (e:any,name:string) => {
        const { value } = e.detail;
        
            if(name==="date"){
                if(selectdate!==value){
                loaddate(value);
                }
            }
            else{
                if(name==="ItemGroupID"&&value!==0){
                    setParams({
                        ...params,
                        [name]: value,
                        ItemID:0
                    });
                    const item = itemlist.find((f:any)=>f.id === 0);
                    setSelecteditem(item);
                }
                else{
                    setParams({
                        ...params,
                        [name]: value
                    });
                }
            }

            if(name ==="InventoryID"){
                const inventory = myInventory.find((f:any)=>f.id === value);
                setCurrentInventory(inventory);
            }
            else if(name ==="ItemGroupID"){
                const itemgroup = itemgrouplist.find((f:any)=>f.id === value);
                setSelecteditemgroup(itemgroup);
            }
            else if(name ==="ItemID"){
                const item = itemlist.find((f:any)=>f.id === value);
                setSelecteditem(item);
            }
            setData([]);
            setIschanged(true);
            
        
    };

    const handleChangeChecked = (e:any,name:string) => {
        const { checked } = e.detail;
        if(data[name]!==checked){
            setData({
                ...data,
                [name]: checked
            });
        }
        setIschanged(true);
        // setChecked(checked);
    };

    useEffect(() => {
        if(location){
            if(location.pathname === "/report/"+"stock"){
           
                loadinventory();
                loaditemgroup();
                loaditem();

            }
        }
        // loaddata();
        // eslint-disable-next-line
      }, [location]);
    

      const loaddate=(code:any)=>{
        var date = new Date();
        var datefrom = new Date(date.getFullYear(), date.getMonth(), 1);
        var dateto = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
       
        switch(code){
            case 'today':
                 datefrom = date;
                 dateto = date;
                 setIscustomdate(false);

                break;
            case 'yesterday':
                
                 datefrom = new Date(date.getFullYear(), date.getMonth(),date.getDate()-1);
                 dateto = new Date(date.getFullYear(), date.getMonth(),date.getDate()-1);
                 setIscustomdate(false);

                break;
            case 'this week':

                 datefrom = new Date(date.setDate(diff));
                 dateto = new Date(datefrom.getFullYear(), datefrom.getMonth(),datefrom.getDate()+7);
                 setIscustomdate(false);

                break;
           
            case 'this month':
                datefrom = new Date(date.getFullYear(), date.getMonth(), 1);
                dateto = new Date(date.getFullYear(), date.getMonth()+1,0);
                setIscustomdate(false);

                break;
           
            case 'custom':
                setIscustomdate(true);
                break;
            default:
                break;

        }

       
        const datefromstring = datefrom.getFullYear() + '-' + (datefrom.getMonth() + 1) + '-' + datefrom.getDate();
        const datetostring = dateto.getFullYear() + '-' + (dateto.getMonth() + 1) + '-' + dateto.getDate();
        
        setSelectdate(code);
        setParams({...params
            ,DateFrom:datefromstring
            ,DateTo:datetostring});
        
      }
    const loaddata=async()=>{
      setShowLoading(true);
      var result:any = await API.insert("report/stock",null).catch(e=>errorhandler(e));
    
      if(result){
          setToastMessage("load complete");
       
      }
      else{

      }
   
    if(ionRefresherRef.current ){
        ionRefresherRef.current!.complete();
        }
      setShowCompleteToast(true);
      setShowLoading(false);
    }

    const loadinventory = async()=>{
        var inventories:any = await API.view("user/myinventory").catch(e=>errorhandler(e));
       
        if(inventories&&inventories.length>0){
            inventories = inventories.sort((a:any,b:any)=>a.Name>b.Name?1:-1);
            inventories.unshift({id:0,Name:"All Inventory",Address:"All Inventory",Description:"All Inventory",Active:true});
            setMyInventory(inventories);
            setParams({...params,InventoryID:inventories[0].id});
            setCurrentInventory(inventories[0]);
        }
      }
      const loaditemgroup = async()=>{
        var itemgrouplist:any = await API.view("report/listitemgroup").catch(e=>errorhandler(e));
       
        if(itemgrouplist&&itemgrouplist.length>0){
            itemgrouplist = itemgrouplist.sort((a:any,b:any)=>a.Name>b.Name?1:-1);
            itemgrouplist.unshift({id:0,Name:"All Group",Address:"All Group",Description:"All Group",Active:true});
            setItemgrouplist(itemgrouplist);
            setParams({...params,ItemGroupID:itemgrouplist[0].id});
            setSelecteditemgroup(itemgrouplist[0]);
        }
      }

      const loaditem = async()=>{
        var itemlist:any = await API.view("report/listitem").catch(e=>errorhandler(e));
       
        if(itemlist&&itemlist.length>0){
            itemlist = itemlist.sort((a:any,b:any)=>a.Name>b.Name?1:-1);
            itemlist.unshift({id:0,Name:"All Item",Address:"All Item",Description:"All Item",Active:true});
            setItemlist(itemlist);
            setParams({...params,ItemID:itemlist[0].id});
            setSelecteditem(itemlist[0]);
        }
      }
      const generatefilename = async(params:any) =>{
          var filename = "report";
          switch(selectdate){
            case "today":
            case "yesterday":
                filename = "_"+currentInventory.Name +"_("+params.DateFrom+")";
                break;
            default:
                filename = "_"+currentInventory.Name +"_("+params.DateFrom+")_("+params.DateTo+")";
                break;
            }

            setFilename(filename);
      }
      const generatereport = async()=>{
        setShowLoading(true);
        var lparams = params;
        var datef = new Date(lparams.DateFrom);
        var datefrom = datef;
        const datefromstring = datefrom.getFullYear() + '-' + (datefrom.getMonth() + 1) + '-' + datefrom.getDate();
        
        var datet = new Date(lparams.DateTo);
        var dateto = datet;
        const datetostring = dateto.getFullYear() + '-' + (dateto.getMonth() + 1) + '-' + dateto.getDate();

        lparams={...lparams,DateFrom:datefromstring,DateTo:datetostring}        

        await setParams(lparams);
        await generatefilename(lparams);
        var dataraw:any = await API.insert("report/stock",lparams).catch(e=>errorhandler(e));
        if(dataraw){
            // setData(data);
            var stock = dataraw["stock"];
            var item = dataraw["item"];
            var LastStock = dataraw["startstock"];
            
            var data:any = [];

            await item.map((i:any)=>{
               
                    const group = itemgrouplist.find((f:any)=>f.id===i.ItemGroupID);

                    data[i.id] = {...i
                        ,LastStock:0
                        ,IN:0
                        ,OUT:0
                        ,ADD:0
                        ,LOSS:0
                        ,MOVEIN:0
                        ,MOVEOUT:0
                        ,CHANGEIN:0
                        ,CHANGEOUT:0
                        ,SALE:0
                        ,Stock:0
                        ,GroupCode:group.Code
                        ,GroupName:group.Name};
                    
                    return i;
            });
            await LastStock.map((l:any)=>{

                if(data[l.ItemID]){
                   
                    if(l.Flow === "IN"){

                        const laststock = parseFloat(data[l.ItemID].LastStock)+parseFloat(l.Quantity);
                        data[l.ItemID] = {...data[l.ItemID],LastStock:laststock,Stock:laststock};

                    }
                    else if(l.Flow === "OUT"){
                        const laststock = parseFloat(data[l.ItemID].LastStock)-parseFloat(l.Quantity);

                        data[l.ItemID] = {...data[l.ItemID],LastStock:laststock,Stock:laststock};

                    }
                }
                return l;
            });

            await stock.map((s:any)=>{

                if(data[s.ItemID]){
                   
                    if(s.Flow === "IN"){
                        data[s.ItemID] = {...data[s.ItemID]
                                        ,IN:parseFloat(data[s.ItemID].IN)+parseFloat(s.Quantity)
                                        ,Stock:parseFloat(data[s.ItemID].Stock)+parseFloat(s.Quantity)
                                    };
                    }
                    else if(s.Flow === "OUT"){
                        data[s.ItemID] = {...data[s.ItemID]
                                        ,OUT:parseFloat(data[s.ItemID].OUT)+parseFloat(s.Quantity)
                                        ,Stock:parseFloat(data[s.ItemID].Stock)-parseFloat(s.Quantity)
                                    };
                    }

                    switch(s.Type){
                        case 'ADD':
                            data[s.ItemID] = {...data[s.ItemID]
                                ,ADD:parseFloat(data[s.ItemID].ADD)+parseFloat(s.Quantity)
                                
                            };
                            break;
                        case 'LOSS':
                            data[s.ItemID] = {...data[s.ItemID]
                                ,LOSS:parseFloat(data[s.ItemID].LOSS)+parseFloat(s.Quantity)
                                
                            };
                            break;
                        case 'MOVE':
                            if(s.Flow === "IN"){
                                data[s.ItemID] = {...data[s.ItemID]
                                    ,MOVEIN:parseFloat(data[s.ItemID].MOVE)+parseFloat(s.Quantity)
                                };
                            }
                            else if(s.Flow === "OUT"){
                                data[s.ItemID] = {...data[s.ItemID]
                                    ,MOVEOUT:parseFloat(data[s.ItemID].MOVE)+parseFloat(s.Quantity)
                                };
                            }
                           
                            break;
                        case 'CHANGE':
                            if(s.Flow === "IN"){
                                data[s.ItemID] = {...data[s.ItemID]
                                    ,CHANGEIN:parseFloat(data[s.ItemID].CHANGE)+parseFloat(s.Quantity)
                                    
                                };
                            }
                            else if(s.Flow === "OUT"){
                                data[s.ItemID] = {...data[s.ItemID]
                                    ,CHANGEOUT:parseFloat(data[s.ItemID].CHANGE)+parseFloat(s.Quantity)
                                    
                                };
                            }
                           
                            break;
                        case 'SALE':
                            data[s.ItemID] = {...data[s.ItemID]
                                ,SALE:parseFloat(data[s.ItemID].SALE)+parseFloat(s.Quantity)
                                
                            };
                            break;

                    }
                    
                }
                return s;
            });
            data = data.sort((a:any,b:any)=>{
                    if (a.GroupName === b.GroupName) {
                    // Price is only important when cities are the same
                    return a.Name > b.Name ? 1: -1;
                    }
                    return a.GroupName > b.GroupName ? 1 : -1;
                
            });
            setData(data);
        }
        else{
           
            setData([]);
            setAlertMessage("no data");
            setShowAlert(true);
        }
        setShowLoading(false);
      }
    const errorhandler = (err:any) =>{
      setToastMessage(err.message);
      if(err.response){
          if(err.response.status==422){
              
          }
      }
      else{
          console.log("errorhandler",err.message);
      }
    }
    
    function getErrorMessage(field:string) {
        if(!Array.isArray(errors)){
            return ;
        }
        else{
        return (
            <div className="validation-errors"> 
                {errors.filter((error:any) => error.field === field).map((filterederror:any) => (
                <div key={field} className="error-message"> 
                <IonIcon slot="icon-only" icon={informationCircleOutline}></IonIcon>
                    {filterederror.message}
                    
                </div>
                
                ))}
            </div>
            
            );
        }
    }
  return (
    <IonPage id="form-page">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{"STOCK REPORT"}</IonTitle>
          <IonButtons slot="end">
          
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      
      <IonContent>
      <IonLoading
          // cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Please wait...'}
          // duration={5000}
        />
        {/* <IonRefresher slot="fixed" ref={ionRefresherRef} onIonRefresh={loaddata}>
          <IonRefresherContent />
        </IonRefresher> */}

        <IonToast
          isOpen={showCompleteToast}
          message={toastMessage}
          duration={2000}
          onDidDismiss={() => setShowCompleteToast(false)}
        />

        <IonCard className="field-card">
        
        <IonCardContent>
        <IonList lines="none">
         <IonItem>
            
            <IonLabel position="fixed" color="primary">Date</IonLabel>
            <Selectfield name={"date"} value={selectdate} 
                    option={{datas:[
                                    {id:'today',Name:'Today'}
                                    ,{id:'yesterday',Name:'Yesterday'}
                                    ,{id:'this week',Name:'This Week'}
                                    ,{id:'this month',Name:'This Month'}
                                    ,{id:'custom',Name:'Custom'}
                                    ]
                                ,label:"Name",value:"id"}} 
                    dataChanged={e=>handleChange(e,"date")}/>
                    
        </IonItem>
        {iscustomdate&&
            <IonItem>
                <IonLabel position="fixed" color="primary">
                Date From
                </IonLabel>
                <DateInput disabled={!iscustomdate} displayFormat="DD MMM YYYY" placeholder="Select Date" value={params.DateFrom} onIonChange={e => handleChange(e,"DateFrom")}></DateInput>
            </IonItem>
        }
        {iscustomdate&&
            <IonItem>
                <IonLabel position="fixed" color="primary">
                Date To
                </IonLabel>
                <DateInput  displayFormat="DD MMM YYYY" placeholder="Select Date" value={params.DateTo} onIonChange={e => handleChange(e,"DateTo")}></DateInput>
            </IonItem>
        }

        <IonItem>
            
            <IonLabel position="fixed" color="primary">Inventory</IonLabel>
            
            {myInventory.length>0&&
                    <Selectfield name={"InventoryID"} value={params["InventoryID"]} option={{datas:myInventory,label:"Name",value:"id"}} dataChanged={e=>handleChange(e,"InventoryID")}/>
                    }
        </IonItem>
        <IonItem>
            
            <IonLabel position="fixed" color="primary">Group</IonLabel>
            
            {itemgrouplist.length>0&&
                    <Selectfield name={"ItemGroupID"} value={params["ItemGroupID"]} option={{datas:itemgrouplist,label:"Name",value:"id"}} dataChanged={e=>handleChange(e,"ItemGroupID")}/>
                    }
        </IonItem>
        <IonItem>
            
            <IonLabel position="fixed" color="primary">Item</IonLabel>
            
            {itemlist.length>0&&
                    <Selectfield name={"ItemID"} value={params["ItemID"]} option={{datas:itemlist.filter((item:any) => params["ItemGroupID"]===0||item.id===0?true: item.ItemGroupID === params["ItemGroupID"]),label:"Name",value:"id"}} dataChanged={e=>handleChange(e,"ItemID")}/>
                    }
        </IonItem>
        <IonItem>
        <IonButton title={"Generate Report"} onClick={() => generatereport() }>
              <IonIcon icon={newspaperOutline}></IonIcon> Generate
            </IonButton>
        </IonItem>
        </IonList>
{data&&data.length>0&&
<IonCardContent>
        <div className = "xlstable">
                <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button"
                    table="report-stock"
                    filename={"stock_"+filename}
                    sheet={"stock_"+filename}
                    buttonText="download"/>
                <table id="report-stock">
                <tr>
                        <th>Report</th>
                        <th>Inventory</th>
                        <th>Group</th>
                        <th>Item</th>
                        <th>DateFrom</th>
                        <th>DateTo</th>
                        
                        
                </tr>
                    <tr>
                        <td>{"STOCK"}</td>
                        <td>{currentInventory.Name}</td>
                        <td>{selecteditemgroup.Name}</td>
                        <td>{selecteditem.Name}</td>
                        <td>{params.DateFrom}</td>
                        <td>{params.DateTo}</td>
                        
                        
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <th className="topfixed">GroupCode</th>
                        <th className="topfixed">GroupName</th>
                        <th className="topfixed">ItemCode</th>
                        <th className="topfixed">ItemName</th>
                        <th className="topfixed">Qty</th>
                        <th className="topfixed">LastStock</th>
                        <th className="topfixed">ADD</th>
                        <th className="topfixed">LOSS</th>
                        <th className="topfixed">MOVE IN</th>
                        <th className="topfixed">MOVE OUT</th>
                        <th className="topfixed">CHANGE IN</th>
                        <th className="topfixed">CHANGE OUT</th>
                        <th className="topfixed">SALE</th>
                        <th className="topfixed">STOCK</th>
                        <th className="topfixed">PRICE</th>
                        <th className="topfixed">VALUE</th>
                    </tr>
                    {data
                    
                
                    .map((element:any,i:any) => {
                        return <tr>
                            {
                            i==0||element.GroupName != data[i-1].GroupName?
                            <>
                            <td>{element.GroupCode}</td>
                            <td>{element.GroupName}</td>
                            </>
                            :
                            <>
                            <td></td>
                            <td></td>
                            </>
                            }
                            <td>{element.Code}</td>
                            <td>{element.Name}</td>
                            <td>{element.QuantityCode}</td>
                            <td>{element.LastStock}</td>
                            <td>{element.ADD}</td>
                            <td>{element.LOSS}</td>
                            <td>{element.MOVEIN}</td>
                            <td>{element.MOVEOUT}</td>
                            <td>{element.CHANGEIN}</td>
                            <td>{element.CHANGEOUT}</td>
                            <td>{element.SALE}</td>
                            <td>{element.Stock}</td>
                            <td>{parseFloat(element.SellPrice)}</td>
                            <td>{parseFloat(element.Stock)*parseFloat(element.SellPrice)}</td>


                            </tr>
                    })}                        
                        <tr>
                        <td></td>
                        <td></td>
                        </tr>
                        <tr>
                        <th>GenerateDate</th>
                        <td>{new Date().toString()}</td>
                        </tr>
                </table>
                
            </div>
            </IonCardContent>
}


        </IonCardContent>
      </IonCard>
         
      </IonContent>
      
      <IonAlert
          isOpen={showAlert}
          onDidDismiss={() => setShowAlert(false)}
          header={alertHeader}
          message={alertMessage}
          buttons={alertButtons}
        />
    </IonPage>
  );
};

export default connect<OwnProps, StateProps, DispatchProps>({
  mapStateToProps: (state, OwnProps) => ({
  }),
  mapDispatchToProps: {
  },
  component: React.memo(StockReport)
})